BaseView = require('base/view')

class BrunchStepView extends BaseView

  template: require('./template')

module.exports = BrunchStepView